<script setup lang="ts">
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
</script>

<template>
    <AccordionItem value="finance" class="border-b-0">
        <AccordionTrigger
            class="py-2 px-4 text-white hover:no-underline hover:bg-neutral-600/50 data-[state=open]:bg-zinc-800"
        >
            <div class="flex items-center">
                <div class="w-6">
                    <FontAwesomeIcon :icon="['fal', 'file-invoice-dollar']" class="size-4!" />
                </div>
                <div class="ml-3 text-xs">Finance</div>
            </div>
        </AccordionTrigger>
        <AccordionContent class="pb-0 text-xs">
            <div class="flex flex-col text-white">
                <RouterLink to="/finance/bank-feeds" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Bank feeds</RouterLink
                >
                <RouterLink to="/finance/billing" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Billing</RouterLink
                >
                <RouterLink to="/finance/cc-payments" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >CC payments</RouterLink
                >
                <RouterLink
                    to="/finance/expired-cards"
                    class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Expired cards</RouterLink
                >
                <RouterLink to="/finance/invoices" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Invoices</RouterLink
                >
                <RouterLink
                    to="/finance/orphaned-invoice-items"
                    class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Orphaned invoice items</RouterLink
                >
                <RouterLink to="/finance/receivables" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Receivables</RouterLink
                >
                <RouterLink to="/finance/receipts" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Receipts</RouterLink
                >
                <RouterLink
                    to="/finance/unsent-invoices"
                    class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Unsent invoices</RouterLink
                >
            </div>
        </AccordionContent>
    </AccordionItem>
</template>

<style scoped>
.router-link-active {
    background-color: rgba(255, 255, 255, 0.1);
}
</style>
